import { AppState } from 'Store'

const selectItems = (state: AppState) => state.archiveBroker.data.entries
const selectOrder = (state: AppState) => state.archiveBroker.currentOrder
const selectTotalItems = (state: AppState) => state.archiveBroker.data.total_entries
const selectParams = (state: AppState) => state.archiveBroker.requestParams
const selectOrderRefusalStatuses = (state: AppState) => state.archiveBroker.orderRefusalStatuses
const selectOrderStatuses = (state: AppState) => state.archiveBroker.orderStatuses

export const archiveBrokerSelector = {
	selectItems,
	selectOrder,
	selectTotalItems,
	selectParams,
	selectOrderRefusalStatuses,
	selectOrderStatuses,
}
